import { render, staticRenderFns } from "./IntroConcept.vue?vue&type=template&id=2b5e9ca3&scoped=true"
import script from "./IntroConcept.vue?vue&type=script&lang=js"
export * from "./IntroConcept.vue?vue&type=script&lang=js"
import style0 from "./IntroConcept.vue?vue&type=style&index=0&id=2b5e9ca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e9ca3",
  null
  
)

export default component.exports